import { roleNames } from "../Constants/generalConfig"

export const intialRole = ({ permission, userData, section }) => {
    let active = false
    if (userData?.roleTitle != roleNames.SERVICE_PROVIDER) {
        let newdata = userData?.allpermission?.find((cur, index) => cur?.title?.toLowerCase() === permission?.toLowerCase())
        // console.log(newdata, 'lllll')
        if (newdata) {
            let conditionData = newdata?.permissionData?.find((cur, index) => cur?.title?.toLowerCase() === section?.toLowerCase())
            active = conditionData?.data?.value
        }

    } else if (userData?.roleTitle == roleNames.SERVICE_PROVIDER) {
        active = true
    } else {
        active = false
    }

    return active
}

export const ClosePicker=(panel) => (
    <div  style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "flex-end",
            padding: "5px",
            height: "95px",
        }}
    >
        <button onClick={() => panel.close()}
            style={{
                padding: "3px 8px",
                border: "none",
                background: "#F47D3A",
                color: "#fff",
                cursor: "pointer",
                fontSize: "12px",
                borderRadius: "4px",
            }}
        >
            Set
        </button>
    </div>
)

export const AutocompleteStyle = {
    "& .MuiOutlinedInput-root": {
      background: "#fcf6f3 !important", 
      display: "flex",
      flexWrap: "wrap",
      maxHeight: "200px", 
      overflowY: "auto",
      boxShadow: "0px 1px 3px #fbbf9e",

      "&::-webkit-scrollbar": {
        width: "6px",  
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#C1C1C1", 
        borderRadius: "4px", 
      },
      "& fieldset": {
        borderColor: "#FDECE6",
      },
      "&:hover fieldset": {
        borderColor: "#FDECE6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#FDECE6",
      },
    },
  };